module.exports = __webpack_public_path__ + "static/media/mario_peng_lee.1ee782c6.png";